import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
//项目招商
import HouseInfo from '../views/projectInvestment/houseInfo/List.vue'
import HouseDetail from '../views/projectInvestment/houseInfo/Detail.vue'
import PurchaseInvestment from '../views/projectInvestment/purchaseInvestment/List.vue'
import PurchaseInvestmentDetail from '../views/projectInvestment/purchaseInvestment/Detail.vue'
//园区动态
import ParkNews from '../views/parkDynamics/news'
import ParkNotice from '../views/parkDynamics/notice'
import TechnologyPolicy from '../views/parkDynamics/technologyPolicy'
import ParkDynamicsDetail from '../views/parkDynamics/Detail'
//孵化服务
import ParkService from '../views/hatchingService/parkService'
import TutorService from '../views/hatchingService/tutorService'
import InvestmentServices from '../views/hatchingService/investmentServices'
import FinancingServices from '../views/hatchingService/financingServices'
import HatchingServiceDetail from '../views/hatchingService/HatchingServiceDetail'
//智慧党建
import Activities from '../views/partyBuilding/activities'
import LearningGarden from '../views/partyBuilding/learningGarden'
import PowerfulCountries from '../views/partyBuilding/powerfulCountries'
import PartyBuildingDetail from '../views/partyBuilding/Detail'

//园区概况
import CompanyProfile from '../views/parkProfile/companyProfile'
import Hornor from '../views/parkProfile/hornor'
import LeftRight from '../components/LeftRight.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: { title: '首页', title_en: 'Home' },
	},
	{
		path: '/ProjectInvestment',
		name: 'ProjectInvestment',
		component: LeftRight,
		meta: { title: '项目招商', title_en: 'Project Investment' },
		redirect: '/ProjectInvestment/house',
		children: [
			{
				path: 'house',
				name: 'house',
				meta: { title: '房源信息', isNav: true },
				component: HouseInfo,
			},
			{
				path: 'houseDetail',
				name: 'houseDetail',
				meta: { title: '房源信息-详情' },
				component: HouseDetail,
			},
			{
				path: 'business',
				name: 'business',
				meta: { title: '采购招商', isNav: true },
				component: PurchaseInvestment,
			},
			{
				path: 'businessDetail/:id',
				name: 'businessDetail',
				meta: { title: '采购招商-详情' },
				component: PurchaseInvestmentDetail,
			},
		],
	},
	{
		path: '/ParkDynamics',
		name: 'ParkDynamics',
		meta: { title: '园区动态', title_en: 'Park Dynamics' },
		component: LeftRight,
		redirect: '/ParkDynamics/news',
		children: [
			{
				path: 'news',
				name: 'news',
				meta: { title: '园区新闻', isNav: true },
				component: ParkNews,
			},
			{
				path: 'notice',
				name: 'notice',
				meta: { title: '园区公告', isNav: true },
				component: ParkNotice,
			},
			{
				path: 'technologyPolicy',
				name: 'technologyPolicy',
				meta: { title: '科技政策', isNav: true },
				component: TechnologyPolicy,
			},
			{
				path: '*/:id',
				meta: { title: '详情' },
				name: 'ParkDynamicsDetail',
				component: ParkDynamicsDetail,
			},
		],
	},
	{
		path: '/HatchingService',
		name: 'HatchingService',
		meta: { title: '孵化服务', title_en: 'Hatching Service' },
		component: LeftRight,
		redirect: '/HatchingService/parkService',
		children: [
			{
				path: 'parkService',
				name: 'parkService',
				meta: { title: '园区服务', isNav: true },
				component: ParkService,
			},
			{
				path: 'tutorService',
				name: 'tutorService',
				meta: { title: '导师服务', isNav: true },
				component: TutorService,
			},
			{
				path: 'investmentServices',
				name: 'investmentServices',
				meta: { title: '投资服务', isNav: true },
				component: InvestmentServices,
			},
			{
				path: 'financingServices',
				name: 'financingServices',
				meta: { title: '融通服务', isNav: true },
				component: FinancingServices,
			},
			{
				path: '*/:id',
				meta: { title: '详情' },
				name: 'HatchingServiceDetail',
				component: HatchingServiceDetail,
			},
		],
	},
	{
		path: '/PartyBuilding',
		name: 'PartyBuilding',
		meta: { title: '智慧党建', title_en: 'Party Building' },
		component: LeftRight,
		redirect: '/PartyBuilding/activities',
		children: [
			{
				path: 'activities',
				name: 'activities',
				meta: { title: '党建活动', isNav: true },
				component: Activities,
			},
			{
				path: 'learningGarden',
				name: 'learningGarden',
				meta: { title: '学习园地', isNav: true },
				component: LearningGarden,
			},
			{
				path: 'powerfulCountries',
				name: 'powerfulCountries',
				meta: { title: '学习强国', isNav: true },
				component: PowerfulCountries,
			},
			{
				path: '*/:id',
				meta: { title: '详情' },
				name: 'PartyBuildingDetail',
				component: PartyBuildingDetail,
			},
		],
	},
	{
		path: '/ParkProfile',
		name: 'ParkProfile',
		meta: { title: '园区概况', title_en: 'Park Profile' },
		component: LeftRight,
		redirect: 'ParkProfile/companyProfile',
		children: [
			{
				path: 'companyProfile',
				name: 'companyProfile',
				meta: { title: '公司简介', isNav: true },
				component: CompanyProfile,
			},
			{
				path: 'hornor',
				name: 'hornor',
				meta: { title: '资质荣誉', isNav: true },
				component: Hornor,
			},
			{
				path: 'memorabilia',
				name: 'memorabilia',
				meta: { title: '大事记', isNav: true },
				component: Hornor,
			},
			{
				path: 'contactUs',
				name: 'contactUs',
				meta: { title: '联系我们', isNav: true },
				component: Hornor,
			},
		],
	},
]

const router = new VueRouter({
	routes,
})
router.beforeEach((to, from, next) => {
	if (to.path === '/PartyBuilding/powerfulCountries') {
		next(false)
		window.location.href = 'https://www.xuexi.cn/index.html'
	} else {
		next()
	}
})
export default router
